// frontend/services/products.js
import api from './api';

export const productService = {
    getProducts: async (params) => {
        const response = await api.get('/products', { params });
        
        // Calculate tax-inclusive price for each product
        if (response.data && response.data.data) {
            response.data.data = response.data.data.map(product => ({
                ...product,
                // Calculate price including VAT (16% by default)
                price_inclusive: product.unit_price * (1 + (product.tax_rate || 16) / 100),
                // Format for display
                price_inclusive_formatted: `KES ${(product.unit_price * (1 + (product.tax_rate || 16) / 100)).toLocaleString()}`,
                // Tax amount per unit
                tax_per_unit: product.unit_price * ((product.tax_rate || 16) / 100)
            }));
        }
        
        return response.data;
    },
    
    getProduct: async (id) => {
        const response = await api.get(`/products/${id}`);
        
        if (response.data && response.data.data) {
            const product = response.data.data;
            response.data.data = {
                ...product,
                price_inclusive: product.unit_price * (1 + (product.tax_rate || 16) / 100),
                price_inclusive_formatted: `KES ${(product.unit_price * (1 + (product.tax_rate || 16) / 100)).toLocaleString()}`,
                tax_per_unit: product.unit_price * ((product.tax_rate || 16) / 100)
            };
        }
        
        return response.data;
    },
    
    createProduct: (data) => api.post('/products', data).then(res => res.data),
    
    updateProduct: (id, data) => api.put(`/products/${id}`, data).then(res => res.data),
    
    deleteProduct: (id) => api.delete(`/products/${id}`).then(res => res.data),
    
    updateStock: (id, data) => api.patch(`/products/${id}/stock`, data).then(res => res.data),
    
    bulkImport: (data) => api.post('/products/bulk-import', data).then(res => res.data),
    
    getCategories: () => api.get('/products/categories').then(res => res.data),
    
    getLowStock: () => api.get('/products/low-stock').then(res => res.data),
    
    getStockMovements: (id, params) => api.get(`/products/${id}/movements`, { params }).then(res => res.data),
    
    getProductAnalytics: (id) => api.get(`/products/${id}/analytics`).then(res => res.data),
    
    // Helper function to calculate tax-inclusive price
    calculateTaxInclusivePrice: (unitPrice, taxRate = 16) => {
        return unitPrice * (1 + taxRate / 100);
    },
    
    // Helper to get tax amount
    calculateTaxAmount: (unitPrice, quantity = 1, taxRate = 16) => {
        return unitPrice * quantity * (taxRate / 100);
    }
};